import React from "react";
import {Image} from "../../../../common/image/Image";
import './RollsetPopupProductList.css'
import {PRODUCT_TYPES} from "../../../../../api/products/productBaseConstants";

export const RollsetPopupProductList = ({products}) => {
    return (
        <div
            className='rollset-detail-products-wrapper'
        >
            <div>
                {
                    Object.entries(products.toJS())
                        .map(([productType, productsData]) => {
                                return Object.values(productsData).map(item => {
                                    item.type = productType;
                                    return item
                                }).sort(
                                    (productData1, productData2) => {
                                        return (productData1.price < productData2.price ? 1 : -1);

                                    })
                                    .map(
                                    productData => <div className="popup-product-child rollset-detail-item-wrapper"
                                                        key={productData.id}>
                                        <Image publicImages={productData.publicImages} className='rollset-detail-item-img'/>
                                        <div className='rollset-detail-item-description-wrapper'>
                                            {(productData.type === PRODUCT_TYPES.roll.id) &&
                                            <>
                                                <p className="popup-product-child-title">{`#${productData.code} ${productData.title}`}
                                                <span className='no-wrap'> {productData.count * 8} шт</span></p>
                                                <p className="popup-product-child-announce">{productData.announce}</p>
                                            </>
                                            }
                                            {productData.type !== PRODUCT_TYPES.roll.id &&
                                                <>
                                                    <p className="popup-product-child-title">{`${productData.title}`}
                                                        {productData.productSubtype !== 'cookie' && productData.type !== PRODUCT_TYPES.poke.id && <span className='no-wrap'> {productData.count * 1} шт</span>}
                                                    </p>
                                                    <p className="popup-product-child-announce">{productData.announce}</p>
                                                </>
                                            }

                                        </div>
                                    </div>
                                )
                            }
                        )
                }
            </div>
        </div>
    )
};
